"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_components_1 = require("@lws/react-components");

var VideoPlayer_1 = require("../VideoPlayer/VideoPlayer");

exports.CustomTeaserImage = function (_a) {
  var videoId = _a.videoId,
      image = _a.image,
      _b = _a.showOverlay,
      showOverlay = _b === void 0 ? true : _b;
  return videoId ? react_1["default"].createElement(VideoPlayer_1.VideoPlayer, {
    videoId: videoId,
    posterImage: react_1["default"].createElement(react_components_1.LsgPicture, {
      fluidData: image.fluid()
    }),
    overlay: showOverlay,
    autoPlay: true,
    loop: true,
    controls: showOverlay
  }) : react_1["default"].createElement(react_components_1.LsgPicture, {
    fluidData: image.fluid(),
    alt: image.metadata().description
  });
};